<template>
  <div class="section" id="liveMenu">
    <div class="columns">
      <div class="column is-8-desktop is-offset-2-desktop">
        <h1 class="subtitle">パンドラの楽しみ方（配信方法）</h1>
        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">
                <span class="has-text-primary mr-2">STEP1</span>配信準備
              </h2>
              <p class="text">配信ツール (OBS) をダウンロードしよう！</p>
            </div>
            <div class="column is-5-widescreen">
              <a href="https://obsproject.com/ja/download" target="_blank">
                <b-button class="button is-primary is-fullwidth">
                  配信ツール (OBS) をダウンロード
                </b-button>
              </a>
            </div>
          </div>
        </div>
        <!-- <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">
                <span class="has-text-primary mr-2">STEP2</span
                >パフォーマー情報を編集
              </h2>
              <p class="text">配信を見てもらえるようにアピールしよう！</p>
            </div>
            <div class="column is-5-widescreen">
              <router-link to="/profile/performer">
                <b-button class="button is-primary is-fullwidth">
                  パフォーマー情報を編集
                </b-button>
              </router-link>
            </div>
          </div>
        </div> -->
        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">
                <span class="has-text-primary mr-2">STEP2</span>配信予定を登録
              </h2>
              <p class="text">配信を見てもらえるようにアピールしよう！</p>
            </div>
            <div class="column is-5-widescreen">
              <router-link to="/live/schedule/Registration">
                <b-button class="button is-primary is-fullwidth"
                  >配信情報を登録</b-button
                >
              </router-link>
            </div>
          </div>
        </div>
        <div class="sectionwrap">
          <div class="columns is-align-items-center">
            <div class="column">
              <h2 class="heading">
                <span class="has-text-primary mr-2">STEP3</span>Keyを取得
              </h2>
              <p class="text">pandoraで配信するための設定情報を取得しよう！</p>
            </div>
            <div class="column is-5-widescreen">
              <router-link to="/live/console">
                <b-button class="button is-primary is-fullwidth"
                  >KeyをGet</b-button
                >
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiveMenu'
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/live-menu.scss';
</style>
